import React, { useEffect, useMemo, Dispatch, SetStateAction } from "react";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { useParams, useRouteMatch } from "react-router-dom";

import { ApiError } from "fe-shared/src/types/common";

import { TRANSFERS_QUERY_KEY } from "consts";
import { Transfer } from "../../../types";

import TransferDetailsView from "../TransferDetailsView";

import * as api from "../modules/api";

interface Props {
  canViewTransferDetails: boolean;
  setLastOpenedTransfersNumber: Dispatch<SetStateAction<string | null>>;
  isStaffView?: boolean;
  hasSidebar?: boolean;
  canEditTransfer?: boolean;
  canCancelTransfer?: boolean;
  canInvalidateTransfer?: boolean;
  canExportHistory?: boolean;
  canViewNotes?: boolean;
  canAddNote?: boolean;
  canExportNotes?: boolean;
  userEmail?: string;
}

const TransferDetailsViewContainer = ({
  setLastOpenedTransfersNumber,
  canViewTransferDetails,
  ...rest
}: Props) => {
  const { transferNumber } = useParams<{ transferNumber: string }>();
  const { path } = useRouteMatch();
  const returnUrl = useMemo(() => path.replace("/:transferNumber", ""), [path]);

  useEffect(() => {
    if (transferNumber) {
      setLastOpenedTransfersNumber(transferNumber);
    }
  }, [setLastOpenedTransfersNumber, transferNumber]);

  const transferQueryKey = [TRANSFERS_QUERY_KEY, transferNumber];
  const transfer = useQuery<Transfer, AxiosError<ApiError>>(
    transferQueryKey,
    api.getTransferInfo,
    {
      keepPreviousData: true,
      enabled: canViewTransferDetails,
    }
  );

  return (
    <TransferDetailsView
      transferQueryKey={transferQueryKey}
      returnUrl={returnUrl}
      transfer={transfer}
      {...rest}
    />
  );
};

export default TransferDetailsViewContainer;
